{
  "categories": [
    {
      "id": "ai",
      "fill_color": "#FC5757",
      "stroke_color": "#A63633",
      "en": "Artificial Intelligence",
      "fr": "Intelligence Artificielle"
    },
    {
      "id": "cloud",
      "fill_color": "#035266",
      "stroke_color": "#014554",
      "en": "Cloud & Infrastructure",
      "fr": "Cloud & Infrastructure"
    },
    {
      "id": "data",
      "fill_color": "#00C0DB",
      "stroke_color": "#00A0B0",
      "en": "Data Platform",
      "fr": "Plateforme Data"
    },
    {
      "id": "nocode",
      "fill_color": "#FF91F0",
      "stroke_color": "#EB73DE",
      "en": "No-Code / Low-code",
      "fr": "No-Code / Low-code"
    },
    {
      "id": "language",
      "fill_color": "#5D74FD",
      "stroke_color": "#3E4FC2",
      "en": "Programming Languages",
      "fr": "Langages de Programmation"
    },
    {
      "id": "security",
      "fill_color": "#F0B021",
      "stroke_color": "#D29614",
      "en": "Cyber-Security",
      "fr": "Cyber-Sécurité"
    }
  ],
  "skills": [
    {
      "growth": 1.03,
      "volume": 666.471,
      "skill": "Penetration Testing",
      "display_name": "Pen Testing",
      "part": 0.12570137724987246,
      "category": "security",
      "en": "Penetration testing is a method used to evaluate the security of computer systems and networks by simulating cyber attacks. It helps identify vulnerabilities and weaknesses by actively probing defenses, crucial for proactive cybersecurity and risk mitigation strategies.",
      "fr": "Penetration testing is a method used to evaluate the security of computer systems and networks by simulating cyber attacks. It helps identify vulnerabilities and weaknesses by actively probing defenses, crucial for proactive cybersecurity and risk mitigation strategies."
    },
    {
      "growth": 1.31,
      "volume": 322.462,
      "skill": "ISO 27001",
      "display_name": "ISO 27001",
      "part": 0.06081872656236862,
      "category": "security",
      "en": "ISO 27001 is an international standard for information security management systems (ISMS). It provides a framework for organizations to establish, implement, maintain, and continually improve their ISMS, ensuring the confidentiality, integrity, and availability of information assets. It helps manage risks and comply with regulations.",
      "fr": "ISO 27001 est une norme internationale pour les systèmes de management de la sécurité de l'information (SMSI). Elle fournit un cadre aux organisations pour établir, mettre en œuvre, maintenir et améliorer continuellement leur SMSI, garantissant la confidentialité, l'intégrité et la disponibilité des actifs informationnels. Elle aide à gérer les risques et à se conformer aux réglementations."
    },
    {
      "growth": 0.83,
      "volume": 200.60999999999999,
      "skill": "Active Directory",
      "display_name": "Active Directory",
      "part": 0.037836534958155595,
      "category": "security",
      "en": "Active Directory is a directory service developed by Microsoft for Windows domain networks. Launched in 1999, it centrally manages network resources, user identities, and security policies. Its hierarchical structure allows for efficient organization and administration of large IT infrastructures, facilitating single sign-on and access control.",
      "fr": "Active Directory est un service d'annuaire développé par Microsoft pour les réseaux de domaine Windows. Lancé en 1999, il gère de manière centralisée les ressources réseau, les identités des utilisateurs et les politiques de sécurité. Sa structure hiérarchique permet une organisation et une administration efficaces des grandes infrastructures informatiques, facilitant le single sign-on et le contrôle d'accès."
    },
    {
      "growth": 1.1,
      "volume": 167.918,
      "skill": "Keycloak",
      "display_name": "Keycloak",
      "part": 0.03167058111312283,
      "category": "security",
      "en": "Keycloak is an open-source identity and access management solution. Created by Red Hat, it simplifies securing applications and services by providing authentication and authorization features. Its major characteristic is enabling single sign-on (SSO) and federation for modern applications and APIs.",
      "fr": "Keycloak est une solution open-source de gestion d'identité et d'accès. Créé par Red Hat, il simplifie la sécurisation des applications et des services en fournissant des fonctionnalités d'authentification et d'autorisation. Sa caractéristique majeure est de permettre le single sign-on (SSO) et la fédération pour les applications et les API modernes."
    },
    {
      "growth": 1.37,
      "volume": 114.422,
      "skill": "CyberArk",
      "display_name": "CyberArk",
      "part": 0.021580838457614673,
      "category": "security",
      "en": "CyberArk is a publicly traded information security company founded in 1999. It specializes in Privileged Access Management (PAM) solutions, providing robust security for critical IT assets and sensitive data. Its platform helps organizations protect against cyber threats by managing and securing privileged accounts and credentials.",
      "fr": "CyberArk est une société de sécurité de l'information cotée en bourse, fondée en 1999. Elle est spécialisée dans les solutions de Privileged Access Management (PAM), offrant une sécurité robuste pour les actifs informatiques critiques et les données sensibles. Sa plateforme aide les organisations à se protéger contre les cybermenaces en gérant et en sécurisant les comptes et les identifiants privilégiés."
    },
    {
      "growth": 0.5800000000000001,
      "volume": 112.193,
      "skill": "Splunk",
      "display_name": "Splunk",
      "part": 0.021160432513635166,
      "category": "security",
      "en": "Splunk is a log aggregator software platform, founded in 2003 by Michael McBride, Rob Das, and Erik Swan. It enables the collection, indexing, searching, and analysis of machine-generated data for IT operations, security, and application monitoring. Its major characteristic is providing real-time operational intelligence from vast data volumes.",
      "fr": "Splunk est une plateforme logicielle d'agrégation de logs, fondée en 2003 par Michael McBride, Rob Das et Erik Swan. Elle permet la collecte, l'indexation, la recherche et l'analyse de données générées par les machines pour les opérations IT, la sécurité et la surveillance des applications. Sa caractéristique principale est de fournir une intelligence opérationnelle en temps réel à partir de vastes volumes de données."
    },
    {
      "growth": 1.3599999999999999,
      "volume": 83.216,
      "skill": "Cloudflare",
      "display_name": "Cloudflare",
      "part": 0.01569515524190158,
      "category": "security",
      "en": "Cloudflare is an American company specializing in internet infrastructure and website security. Founded in 2009, it provides a wide range of services including DDoS mitigation, CDN, DNS, and WAF, acting as a reverse proxy and intermediary between users and their hosted content or applications.",
      "fr": "Cloudflare est une entreprise américaine spécialisée dans l'infrastructure internet et la sécurité des sites web. Fondée en 2009, elle propose une large gamme de services incluant le DDoS mitigation, le CDN, le DNS et le WAF, agissant comme un reverse proxy et un intermédiaire entre les utilisateurs et leur contenu ou applications hébergés."
    },
    {
      "growth": 1.08,
      "volume": 48.295,
      "skill": "Red Teaming",
      "display_name": "Red team",
      "part": 0.00910879545288931,
      "category": "security",
      "en": "Red Teaming is a security assessment methodology where a dedicated group simulates adversarial attacks to identify vulnerabilities and provide feedback to an organization. Its primary characteristic is its proactive, offensive approach to enhancing defensive strategies and overall security posture.",
      "fr": "Red Teaming est une méthodologie d'évaluation de la sécurité où un groupe dédié simule des attaques adverses pour identifier les vulnérabilités et fournir un retour d'information à une organisation. Sa caractéristique principale est son approche proactive et offensive pour améliorer les stratégies défensives et la posture de sécurité globale."
    },
    {
      "growth": 1.03,
      "volume": 45.323,
      "skill": "PCI DSS",
      "display_name": "PCI DSS",
      "part": 0.008548254194249967,
      "category": "security",
      "en": "PCI DSS is a set of security standards designed to ensure that all companies that accept, process, store or transmit credit card information maintain a secure environment. It was established by the major credit card brands.",
      "fr": "PCI DSS est un ensemble de normes de sécurité conçues pour garantir que toutes les entreprises qui acceptent, traitent, stockent ou transmettent des informations de carte de crédit maintiennent un environnement sécurisé. Il a été établi par les principales marques de cartes de crédit."
    },
    {
      "growth": 1.12,
      "volume": 38.636,
      "skill": "NIS 2 Directive",
      "display_name": "NIS 2",
      "part": 0.0072870363623114475,
      "category": "security",
      "en": "The NIS 2 Directive is a European Union cybersecurity law, implemented in 2024. It significantly expands the scope of essential and important entities covered by its predecessor, aiming to enhance the overall cybersecurity resilience and incident response capabilities across member states.",
      "fr": "La directive NIS 2 est une loi de l'Union européenne sur la cybersécurité, mise en œuvre en 2024. Elle élargit considérablement le champ d'application des entités essentielles et importantes couvertes par son prédécesseur, dans le but d'améliorer la résilience globale en matière de cybersécurité et les capacités de réponse aux incidents dans les États membres."
    },
    {
      "growth": 1.0,
      "volume": 37.15,
      "skill": "Okta",
      "display_name": "Okta",
      "part": 0.007006765732991777,
      "category": "security",
      "en": "Okta is an American information technology company founded in 2009. It specializes in identity and access management solutions, providing cloud software that helps companies manage and secure user access to applications.",
      "fr": "Okta est une entreprise américaine de technologie de l'information fondée en 2009. Elle est spécialisée dans les solutions d'identity and access management, fournissant des logiciels cloud qui aident les entreprises à gérer et sécuriser l'accès des utilisateurs aux applications."
    },
    {
      "growth": 0.89,
      "volume": 32.692,
      "skill": "Vault",
      "display_name": "Vault",
      "part": 0.0061659538450327634,
      "category": "security",
      "en": "HashiCorp Vault is a secrets management tool and identity-based security platform created by HashiCorp. It enables centralized management of sensitive data like passwords and API keys, offering encryption, secure storage, and fine-grained access control for cloud-native environments and applications.",
      "fr": "HashiCorp Vault est un outil de gestion des secrets et une plateforme de sécurité basée sur l'identité créée par HashiCorp. Il permet la gestion centralisée des données sensibles telles que les mots de passe et les clés API, offrant le chiffrement, le stockage sécurisé et le contrôle d'accès granulaire pour les environnements cloud-native et les applications."
    },
    {
      "growth": 4.7,
      "volume": 22.29,
      "skill": "Cyber threat intelligence",
      "display_name": "Threat Intelligence",
      "part": 0.004204059439795066,
      "category": "security",
      "en": "Cyber Threat Intelligence (CTI) is data used to detect or predict cyberattacks. It helps organizations understand potential threats, enabling proactive defense strategies against malicious actors and sophisticated cyber campaigns. CTI is crucial for informed security decision-making in today's evolving threat landscape.",
      "fr": "Cyber Threat Intelligence (CTI) est des données utilisées pour détecter ou prédire des cyberattaques. Elle aide les organisations à comprendre les menaces potentielles, permettant des stratégies de défense proactives contre les acteurs malveillants et les campagnes cyber sophistiquées. Le CTI est crucial pour une prise de décision éclairée en matière de sécurité dans le paysage des menaces d'aujourd'hui en évolution."
    },
    {
      "growth": 0.76,
      "volume": 14.86,
      "skill": "EBIOS",
      "display_name": "EBIOS",
      "part": 0.0028027062931967107,
      "category": "security",
      "en": "EBIOS (Expression des Besoins en Études de Sûreté) is a risk evaluation method in computer science, particularly for security and safety. Developed in France, it provides a structured approach to identifying, analyzing, and managing risks throughout the system lifecycle, ensuring robust security postures.",
      "fr": "EBIOS (Expression des Besoins en Études de Sûreté) est une méthode d'évaluation des risques en informatique, particulièrement pour la sécurité et la sûreté. Développée en France, elle fournit une approche structurée pour identifier, analyser et gérer les risques tout au long du cycle de vie du système, assurant des postures de sécurité robustes."
    },
    {
      "growth": 0.55,
      "volume": 11.888,
      "skill": "Qualys",
      "display_name": "Qualys",
      "part": 0.0022421650345573686,
      "category": "security",
      "en": "Qualys is a US-based cybersecurity company founded in 1999. It provides a unified platform for IT, security, and compliance solutions, offering cloud-based services for vulnerability management, compliance monitoring, and web application security. Qualys helps organizations manage and reduce cyber risk across their entire IT environment.",
      "fr": "Qualys est une société américaine de cybersécurité fondée en 1999. Elle fournit une plateforme unifiée pour les solutions IT, de sécurité et de conformité, offrant des services cloud pour la gestion des vulnérabilités, la surveillance de la conformité et la sécurité des applications web. Qualys aide les organisations à gérer et à réduire le cyber-risque sur l'ensemble de leur environnement IT."
    },
    {
      "growth": 0.75,
      "volume": 11.145,
      "skill": "SOC 2",
      "display_name": "SOC 2",
      "part": 0.002102029719897533,
      "category": "security",
      "en": "SOC 2 (System and Organization Controls 2) is an auditing standard developed by the AICPA. It provides a framework for service organizations to manage customer data based on principles of security, availability, processing integrity, confidentiality, and privacy. It is crucial for establishing trust and demonstrating robust data protection practices.",
      "fr": "SOC 2 (System and Organization Controls 2) est une norme d'audit développée par l'AICPA. Elle fournit un cadre aux organisations de services pour gérer les données des clients sur la base des principes de sécurité, de disponibilité, d'intégrité du traitement, de confidentialité et de vie privée. Il est crucial d'établir la confiance et de démontrer des pratiques robustes de protection des données."
    },
    {
      "growth": 1.53,
      "volume": 10.402,
      "skill": "CrowdStrike",
      "display_name": "CrowdStrike",
      "part": 0.0019618944052376976,
      "category": "security",
      "en": "CrowdStrike is an American cybersecurity technology company specializing in endpoint security. Founded in 2011, it offers a cloud-native platform that provides threat intelligence, continuous monitoring, and automated remediation to protect organizations against advanced cyberattacks.",
      "fr": "CrowdStrike est une société américaine de technologie de cybersécurité spécialisée dans la sécurité des endpoints. Fondée en 2011, elle propose une plateforme cloud-native qui fournit threat intelligence, monitoring continu et automated remediation pour protéger les organisations contre les cyberattaques avancées."
    },
    {
      "growth": 0.38,
      "volume": 8.916,
      "skill": "Microsoft Defender",
      "display_name": "Microsoft Defender",
      "part": 0.0016816237759180264,
      "category": "security",
      "en": "Microsoft Defender is a comprehensive security suite designed for multi-domain protection of enterprise IT assets. It offers advanced threat detection, prevention, and response capabilities, safeguarding an organization's digital infrastructure against a wide range of cyber threats.",
      "fr": "Microsoft Defender est une suite de sécurité complète conçue pour la protection multi-domaines des actifs informatiques d'entreprise. Elle offre des capacités avancées de détection, de prévention et de réponse aux menaces, protégeant l'infrastructure numérique d'une organisation contre un large éventail de cybermenaces."
    },
    {
      "growth": 0.8200000000000001,
      "volume": 8.916,
      "skill": "Microsoft Sentinel",
      "display_name": "Microsoft Sentinel",
      "part": 0.0016816237759180264,
      "category": "security",
      "en": "Microsoft Sentinel (formerly Azure Sentinel) is a cloud-native Security Information and Event Management (SIEM) and Security Orchestration, Automation, and Response (SOAR) solution. Offered by Microsoft on Azure, it provides intelligent security analytics and threat intelligence to detect and respond to threats across an organization's digital estate.",
      "fr": "Microsoft Sentinel (anciennement Azure Sentinel) est une solution cloud-native de Security Information and Event Management (SIEM) et de Security Orchestration, Automation, and Response (SOAR). Proposée par Microsoft sur Azure, elle fournit des analyses de sécurité intelligentes et des threat intelligence pour détecter et répondre aux menaces sur l'ensemble du patrimoine numérique d'une organisation."
    },
    {
      "growth": 1.34,
      "volume": 8.173,
      "skill": "SentinelOne",
      "display_name": "SentinelOne",
      "part": 0.0015414884612581909,
      "category": "security",
      "en": "SentinelOne is an AI-powered cybersecurity platform developed by SentinelOne. It offers endpoint security solutions, leveraging machine learning and behavioral analysis to detect, prevent, and respond to cyber threats across devices and cloud environments in real-time.",
      "fr": "SentinelOne est une plateforme de cybersécurité alimentée par l'IA développée par SentinelOne. Elle offre des solutions de sécurité des endpoints, exploitant le machine learning et l'analyse comportementale pour détecter, prévenir et répondre aux cybermenaces sur les appareils et les environnements cloud en temps réel."
    },
    {
      "growth": 1.83,
      "volume": 7.43,
      "skill": "ANSSI",
      "display_name": "ANSSI",
      "part": 0.0014013531465983553,
      "category": "security",
      "en": "ANSSI is the French national agency for information and network security. Established in 2009, it provides expertise and operational services to protect critical national infrastructure and promote cybersecurity best practices across France.",
      "fr": "ANSSI est l'agence nationale française de la sécurité des systèmes d'information. Établie en 2009, elle fournit une expertise et des services opérationnels pour protéger les infrastructures nationales critiques et promouvoir les meilleures pratiques en matière de cybersécurité à travers la France."
    },
    {
      "growth": 1.83,
      "volume": 7.43,
      "skill": "Tenable",
      "display_name": "Tenable",
      "part": 0.0014013531465983553,
      "category": "security",
      "en": "Tenable is a software company specializing in cybersecurity solutions. Founded in 2002 by Ron Gula, Renaud Deraison, and Jack Huffard, Tenable provides a platform for managing and reducing cyber risk. Their flagship product, Tenable.io, offers comprehensive vulnerability management and continuous monitoring across cloud and traditional IT environments.",
      "fr": "Tenable est une société de logiciels spécialisée dans les solutions de cybersécurité. Fondée en 2002 par Ron Gula, Renaud Deraison et Jack Huffard, Tenable fournit une plateforme pour gérer et réduire le cyber risque. Leur produit phare, Tenable.io, offre une gestion complète des vulnérabilités et une surveillance continue dans les environnements cloud et IT traditionnels."
    },
    {
      "growth": 0.39,
      "volume": 7.43,
      "skill": "OWASP",
      "display_name": "OWASP",
      "part": 0.0014013531465983553,
      "category": "security",
      "en": "OWASP is a non-profit, open community dedicated to improving software security. Founded in 2001, it develops open-source software, standards, and documentation, offering practical guidance and tools to help organizations build and maintain secure applications.",
      "fr": "OWASP est une communauté ouverte à but non lucratif dédiée à l'amélioration de la sécurité des logiciels. Fondée en 2001, elle développe des logiciels open-source, des standards et de la documentation, offrant des conseils pratiques et des outils pour aider les organisations à construire et maintenir des applications sécurisées."
    },
    {
      "growth": 0.18999999999999995,
      "volume": 5.944,
      "skill": "Forgerock",
      "display_name": "Forgerock",
      "part": 0.0011210825172786843,
      "category": "security",
      "en": "ForgeRock is an identity and access management (IAM) platform. Created by ForgeRock Inc., it provides a unified system for managing digital identities across various applications and services, enabling secure and seamless user access. Its key characteristic is its comprehensive suite of IAM solutions.",
      "fr": "ForgeRock est une plateforme d'identity and access management (IAM). Créée par ForgeRock Inc., elle fournit un système unifié pour gérer les identités numériques à travers diverses applications et services, permettant un accès utilisateur sécurisé et transparent. Sa caractéristique clé est sa suite complète de solutions IAM."
    },
    {
      "growth": 6.58,
      "volume": 4.458,
      "skill": "ISO 21434",
      "display_name": "ISO 21434",
      "part": 0.0008408118879590132,
      "category": "security",
      "en": "ISO 21434 is an international standard published in 2021, focusing on cybersecurity engineering for road vehicles. It provides a framework and requirements for managing risks related to cybersecurity throughout the entire lifecycle of automotive electronic systems and components, ensuring safety and security on the road.",
      "fr": "ISO 21434 est une norme internationale publiée en 2021, axée sur l'ingénierie de la cybersécurité pour les véhicules routiers. Elle fournit un cadre et des exigences pour la gestion des risques liés à la cybersécurité tout au long du cycle de vie des systèmes et composants électroniques automobiles, garantissant la sécurité et la sûreté sur la route."
    },
    {
      "growth": 0.51,
      "volume": 4.458,
      "skill": "Rapid7",
      "display_name": "Rapid7",
      "part": 0.0008408118879590132,
      "category": "security",
      "en": "Rapid7 is a cybersecurity firm offering a unified platform for security operations. Founded in 2004, it provides solutions for vulnerability management, threat detection, and incident response, enabling organizations to improve their security posture and manage cyber risks effectively.",
      "fr": "Rapid7 est une entreprise de cybersécurité proposant une plateforme unifiée pour les opérations de sécurité. Fondée en 2004, elle fournit des solutions pour la gestion des vulnérabilités, la détection des menaces et la réponse aux incidents, permettant aux organisations d'améliorer leur posture de sécurité et de gérer efficacement les cyber-risques."
    },
    {
      "growth": 1.6400000000000001,
      "volume": 4.458,
      "skill": "blue team",
      "display_name": "Blue team",
      "part": 0.0008408118879590132,
      "category": "security",
      "en": "A Blue Team is a group within an organization responsible for defending computer systems and networks against cyberattacks. They provide security feedback, conduct proactive threat hunting, and implement defensive measures to ensure the integrity and availability of digital assets.",
      "fr": "Une Blue Team est un groupe au sein d'une organisation responsable de la défense des systèmes informatiques et des réseaux contre les cyberattaques. Ils fournissent des retours de sécurité, mènent une chasse proactive aux menaces et mettent en œuvre des mesures défensives pour assurer l'intégrité et la disponibilité des actifs numériques."
    },
    {
      "growth": 0.31999999999999995,
      "volume": 3.715,
      "skill": "Checkmarx",
      "display_name": "Checkmarx",
      "part": 0.0007006765732991777,
      "category": "security",
      "en": "Checkmarx is a cybersecurity company offering a suite of application security testing (AST) solutions. It provides tools for static, dynamic, and interactive application security testing, helping organizations identify and remediate vulnerabilities throughout the software development lifecycle. Their platform aims to integrate security seamlessly into DevOps workflows.",
      "fr": "Checkmarx est une entreprise de cybersécurité proposant une suite de solutions d'application security testing (AST). Elle fournit des outils pour le static, dynamic, et interactive application security testing, aidant les organisations à identifier et à corriger les vulnérabilités tout au long du software development lifecycle. Leur plateforme vise à intégrer la sécurité de manière transparente dans les DevOps workflows."
    },
    {
      "growth": 0.21999999999999997,
      "volume": 3.715,
      "skill": "QRadar Network Insights",
      "display_name": "QRadar",
      "part": 0.0007006765732991777,
      "category": "security",
      "en": "QRadar Network Insights is a deep network packet analysis software and appliance. It provides advanced visibility and security analytics by inspecting network traffic in real-time, enabling faster threat detection and response for security operations centers.",
      "fr": "QRadar Network Insights est un logiciel et un appareil d'analyse approfondie des paquets réseau. Il offre une visibilité avancée et des analyses de sécurité en inspectant le trafic réseau en temps réel, permettant une détection et une réponse plus rapides des menaces pour les centres d'opérations de sécurité."
    },
    {
      "growth": 0.73,
      "volume": 2.972,
      "skill": "MITRE ATT&CK",
      "display_name": "MITRE ATT&CK",
      "part": 0.0005605412586393422,
      "category": "security",
      "en": "The MITRE ATT&CK framework is a globally accessible knowledge base of adversary tactics and techniques. Maintained by the MITRE Corporation, it provides a common language and understanding for cybersecurity professionals to map and defend against cyber threats effectively.",
      "fr": "Le framework MITRE ATT&CK est une base de connaissances mondialement accessible de tactiques et techniques adverses. Maintenu par la MITRE Corporation, il fournit un langage commun et une compréhension pour les professionnels de la cybersécurité afin de cartographier et de se défendre efficacement contre les cybermenaces."
    },
    {
      "growth": 3.29,
      "volume": 2.229,
      "skill": "ISO 7816",
      "display_name": "ISO 7816",
      "part": 0.0004204059439795066,
      "category": "security",
      "en": "ISO 7816 is a series of international standards defining the physical characteristics and communication protocols for smart cards. Published by the International Organization for Standardization, it ensures interoperability between smart cards and card-reading devices across various applications, including electronic identification and secure transactions.",
      "fr": "ISO 7816 est une série de normes internationales définissant les caractéristiques physiques et les protocoles de communication pour les cartes à puce. Publiée par l'International Organization for Standardization, elle assure l'interopérabilité entre les cartes à puce et les appareils de lecture de cartes dans diverses applications, y compris l'identification électronique et les transactions sécurisées."
    },
    {
      "growth": 0.27,
      "volume": 1.486,
      "skill": "Proofpoint",
      "display_name": "Proofpoint",
      "part": 0.0002802706293196711,
      "category": "security",
      "en": "Proofpoint is a leading cybersecurity company founded in 2002. They specialize in protecting organizations from advanced threats, offering solutions for email security, information protection, and user awareness training. Their focus is on advanced threat protection and data loss prevention.",
      "fr": "Proofpoint est une entreprise leader en cybersécurité fondée en 2002. Ils se spécialisent dans la protection des organisations contre les menaces avancées, offrant des solutions pour la sécurité de la messagerie électronique, la protection des informations et la formation de sensibilisation des utilisateurs. Leur objectif est la protection contre les menaces avancées et la prévention de la perte de données."
    },
    {
      "growth": 2.19,
      "volume": 1.486,
      "skill": "MEHARI",
      "display_name": "MEHARI",
      "part": 0.0002802706293196711,
      "category": "security",
      "en": "MEHARI is a software tool designed for the analysis and design of systems, particularly in the context of cybersecurity and system safety. It enables formal modeling and verification, aiding in the assessment and improvement of system reliability and security properties.",
      "fr": "MEHARI est un outil logiciel conçu pour l'analyse et la conception de systèmes, particulièrement dans le contexte de la cybersécurité et de la sûreté des systèmes. Il permet la modélisation et la vérification formelles, aidant à l'évaluation et à l'amélioration de la fiabilité et des propriétés de sécurité des systèmes."
    },
    {
      "growth": 1.1,
      "volume": 0.743,
      "skill": "Artificial Intelligence Act",
      "display_name": "AI Act",
      "part": 0.00014013531465983554,
      "category": "security",
      "en": "The EU AI Act is a landmark regulation by the European Union aimed at establishing clear rules for artificial intelligence. It categorizes AI systems based on risk, imposing obligations to ensure safety, transparency, and fundamental rights protection. Its goal is to foster trustworthy AI innovation within the EU.",
      "fr": "La loi européenne sur l'IA est une réglementation historique de l'Union européenne visant à établir des règles claires pour l'intelligence artificielle. Elle catégorise les systèmes d'IA en fonction du risque, imposant des obligations pour garantir la sécurité, la transparence et la protection des droits fondamentaux. Son objectif est de favoriser l'innovation en matière d'IA digne de confiance au sein de l'UE."
    },
    {
      "growth": 0.37,
      "volume": 0.743,
      "skill": "Cybereason",
      "display_name": "Cybereason",
      "part": 0.00014013531465983554,
      "category": "security",
      "en": "Cybereason is a cybersecurity company that offers an endpoint prevention, detection, and response (EPDR) platform. Launched in 2012, it focuses on providing advanced threat hunting and real-time incident response capabilities to protect organizations from sophisticated cyberattacks.",
      "fr": "Cybereason est une entreprise de cybersécurité qui propose une plateforme EPDR (endpoint prevention, detection, and response). Lancée en 2012, elle se concentre sur la fourniture de capacités avancées de threat hunting et de real-time incident response pour protéger les organisations contre les cyberattaques sophistiquées."
    },
    {
      "growth": 0.37,
      "volume": 0.743,
      "skill": "Suricata",
      "display_name": "Suricata",
      "part": 0.00014013531465983554,
      "category": "security",
      "en": "Suricata is an open-source network intrusion detection and prevention system. Developed by the Open Information Security Foundation, it analyzes network traffic in real-time to identify malicious activity, policy violations, and threats, providing robust security for modern networks.",
      "fr": "Suricata est un système open-source de détection et de prévention d'intrusion réseau. Développé par l'Open Information Security Foundation, il analyse le trafic réseau en temps réel pour identifier les activités malveillantes, les violations de politique et les menaces, offrant une sécurité robuste pour les réseaux modernes."
    }
  ]
}